// extracted by mini-css-extract-plugin
module.exports = {"skip-link":"skip-link_skip-link__rqGnt"};